module.exports = __webpack_public_path__ + "img/wangjian.09df2828.jpg";